export class Gauge {
    constructor(
        public proveedor: string,
        public valor: number
    ){}
}